{
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  scrollbarWidth &&
    document.body.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
}


/**
 * @param {*} endpoint of the function
 * @param {*} method fetch method
 * @param {*} data optional data. default ""
 * @returns the response json or an error which will be thrown
 */
const fetching = async function (endpoint, method, data = "", headers = {}) {
  try {
    const response = await fetch(endpoint, {
      method: method,
      ...(data ? { body: data } : {}),
      headers: {
        Authorization: window.localStorage.getItem("token"),
        ...headers
      },
    });
    
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

String.prototype.toCamelCase = function () {
  return this.replace(/[^a-zA-Z0-9]+(.)/g, (match, char) => char.toUpperCase());
};

String.prototype.toKebabCase = function () {
  return this.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};

String.prototype.toLowerDashed = function (ignored = []) {
  const replacements = {
    " ": "-",
    "?": "",
    "!": "",
    ".": "",
    ",": "",
    "\"": "",
    "'": "",
    ":": "",
    "/": "-",
    "(": "",
    ")": "",
    ";": "",
    "%": "",
    "\\": "-",
    "&": "-",
    "[": "",
    "]": "",
    "{": "",
    "}": "",
    "|": "-",
    "#": "sharp",
    ">": "",
    "<": "",
    "~": "",
    "`": "",
    "+": "",
    "@": "",
    "^": "",
    "*": "",
    "=": "",
    "$": ""
  };

  return this
    .toLowerCase()
    .trim()
    .split("")
    .map(char => ignored.includes(char) ? char : (replacements.hasOwnProperty(char) ? replacements[char] : char))
    .join("");
};

Storage.prototype.getProgressJson = function () {
  try {
    const progressData = this.getItem("progressJson");
    return progressData ? JSON.parse(progressData) : null;
  } catch (error) {
    console.error("Error parsing progressJson:", error);
    return null;
  }
};

Storage.prototype.getRegistrationId = function () {
  const { course_registrations: courseRegistrations } = this.getProgressJson();
  const path = location.pathname
  const courseName = path.match(/course\/([^\/]+)/)[1];

  return courseRegistrations.reduce(
    // check where coursename == unique identifier and return id
    (acc, reg) => {
      return courseName === reg.course["unique_identifer"]
        ? reg["course_registration_id"]
        : acc;
    }, 0
  );
};

Storage.prototype.getCourses = function () {
  const progressJson = this.getProgressJson();
  if (!progressJson || !progressJson["course_registrations"]) return [];
  const courses = progressJson["course_registrations"].map((course) => {
    if (!course) return null;
    const courseElement =
      course["last_course_registration_element"]?.["course_element"];
    const name = course.course?.["unique_identifer"];
    if (!name) return null;
    const path = courseElement?.["path"];
    if (!path) course["last_course_registration_element"] = undefined;
    else {
      const completePath = `course/${name}/${path}`;
      course["last_course_registration_element"] = completePath;
    }
    const nextPath = course["next_element"]?.path;

    if (nextPath) {
      const completePath = `course/${name}/${nextPath}`;
      course["next_element"] = completePath;
    }
    if (!nextPath) course["next_element"] = undefined;
    return course;
  }).filter(Boolean); // Remove any null entries
  return courses;
};

// on every localstorage setItem event it will send out a custom event
Storage.prototype.setItem = function (key, value) {
  this[key] = value;
  if (key == "notifications") {
    const event = new Event("change.localstorage", { bubbles: true });
    document.body.dispatchEvent(event);
  }
};

// on every checkbox or radiobutton check it will send out a change event
HTMLInputElement.prototype.setChecked = function (checked) {
  const event = new Event("change", { bubbles: true });
  this.checked = checked;
  switch (this.type) {
    case "checkbox":
      this.dispatchEvent(event);
      break;
    case "radio":
      checked && this.dispatchEvent(event);
      break;
  }
};

// Prototype extension to make XPathResult iterable:
// Source: https://www.anycodings.com/1questions/1320706/how-to-use-arrayfrom-with-a-xpathresult
XPathResult.prototype[Symbol.iterator] = function* () {
  switch (this.resultType) {
    case XPathResult.UNORDERED_NODE_ITERATOR_TYPE:
    case XPathResult.ORDERED_NODE_ITERATOR_TYPE:
      let result;
      while ((result = this.iterateNext())) {
        yield result;
      }
      break;
    case XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE:
    case XPathResult.ORDERED_NODE_SNAPSHOT_TYPE:
      for (let i = 0; i < this.snapshotLength; i++) {
        yield this.snapshotItem(i);
      }
      break;
    default:
      yield this.singleNodeValue;
      break;
  }
};
